import styled from '@emotion/styled';

import { COLORS } from '../../styles/colors';

export const Container = styled.div`
  min-height: calc(100vh - 40px);
  overflow: hidden;
  background-color: ${COLORS.slategray5};
`;

export const Scroller = styled.div`
  overflow: auto;
  height: 100%;
  padding: 40px 0;
`;

export const Viewport = styled.div <{ width: number }>`
  position: relative;
  width: ${({ width }) => `${width}px`};
  min-height: 700px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: content-box;
`;

export const Content = styled.div <{ shadow: boolean }>`
  position: relative;
  min-height: inherit;
  color: ${COLORS.gray80};
  font-family: 'Noto Sans KR', 'Apple SD Gothic Neo', '맑은 고딕',
    'Malgun Gothic', sans-serif;
  letter-spacing: -0.4px;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  background-color: ${COLORS.gray0};
  ${({ shadow }) => shadow &&
    `
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
    `}
  &:before {
    content: '';
    display: block;
    height: 1px;
    margin-top: -1px;
    visibility: hidden;
  }
`;
